import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6 text-right" }
const _hoisted_2 = { class: "text-lg font-semibold mb-2 justify-end" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("languages")), 1),
    _createElementVNode("p", {
      innerHTML: _ctx.$t('languagesContent')
    }, null, 8, _hoisted_3)
  ]))
}